import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useLayoutEffect, useState } from 'react';
import { createTechnicians, fetchBeaconsStore, SearchBeaconsStores } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useDebounce } from '@/utils/DebounceHook';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { BeaconStore } from '../beaconStore/BeaconStoreColumns';
import axios from 'axios';
import SpinnerForm from '../spinnner/SpinnerForm';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showCreateTechnicianDrawer: boolean;
    setShowCreateTecnicianDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    getTechnicians: any
}
const CreateTechnicianDrawer: React.FC<ProductsDrawerProps> = ({ showCreateTechnicianDrawer, setShowCreateTecnicianDrawer, getTechnicians }) => {
    const onCLose = () => setShowCreateTecnicianDrawer(false)
    const [submitting, setSubmitting] = useState(false)
    const [form] = Form.useForm();
    const [searchTermForBeaconStores, setSearchTermForBeaconStores] = useState('')
    const [beaconStoresToDisplay, setBeaconStoresToDisplay] = useState<BeaconStore[]>([])
    const [beaconStoresOptions, setBeaconStoresOptions] = useState([])
    const [loadingBeaconStore, setLoadingBeaconStore] = useState<boolean>(true)
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()

    const getBeaconStores = () => {
        let isMounted = true;
        setLoadingBeaconStore(true)
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconStore', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: BeaconStore[]) => {
                if (isMounted) {
                    setBeaconStoresToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoadingBeaconStore(false)
            })
        return () => {
            isMounted = false
            controller.abort()
        }
    }

    useLayoutEffect(() => {
        getBeaconStores()
    }, [])



    const searchBeaconStoresBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController();
        axiosPrivate.get(`/api/v1/beaconStore/search?query=${searchTermForBeaconStores}`, {
            signal: controller.signal
        })
            .then((response) => {
                if (isMounted) {
                    setBeaconStoresToDisplay(response.data.data);
                }
            })
            .catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForBeaconStores, 500, searchBeaconStoresBySearchTerm)

    useLayoutEffect(() => {
        const updatedBeaconStoresOptions: any = beaconStoresToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }))
        setBeaconStoresOptions(updatedBeaconStoresOptions)
    }, [beaconStoresToDisplay])

    const filterBeaconStoresOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }

    const handleBeaconStoresChange = (value: any) => {
        setSearchTermForBeaconStores(value)
    }


    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (technician: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/technicians', technician, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "technician successfully added",
                    `${technician.first_name} was added to the system`,
                    'topRight'
                )
            }
            getTechnicians()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    return <Drawer
        title="Create Technicians"
        width={720}
        onClose={onCLose}
        open={showCreateTechnicianDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >
        {(loadingBeaconStore) ? (
            <div>
                <SpinnerForm />
            </div>
        ) : (
            <Form layout="vertical"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                form={form}
                hideRequiredMark>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="beacon_store_id"
                            label="Beacon Store Name "
                            rules={[{ required: true, message: 'Please slect product name' }]}
                        >
                            <Select
                                placeholder="Please select product name"
                                showSearch
                                style={{ borderColor: 'black' }}
                                onSearch={handleBeaconStoresChange}
                                filterOption={filterBeaconStoresOptions}
                            >
                                {beaconStoresOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="first_name"
                            label="First Name"
                            rules={[{ required: true, message: 'Please enter first name' }]}
                        >
                            <Input
                                placeholder="Please enter first name"
                                className='focus:border-green-500 hover:border-green-500'
                                autoComplete="off" 
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="last_name"
                            label="Last Name"
                            rules={[{ required: true, message: 'Please enter Last Name' }]}
                        >
                            <Input
                                placeholder="Please enter Last Name"
                                className='focus:border-green-500 hover:border-green-500'
                                autoComplete="off" 
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="email"
                            label="email"
                            rules={[{ required: true, message: 'Please enter email' }]}
                        >
                            <Input
                                placeholder="Please enter email"
                                className='focus:border-green-500 hover:border-green-500'
                                autoComplete="off" 
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="telephone"
                            label="Telephone"
                            rules={[{ required: true, message: 'Please enter telephone' }]}
                        >
                            <Input
                                type="tel"
                                placeholder="Please enter telephone"
                                className='focus:border-green-500 hover:border-green-500'
                                autoComplete="off" 
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    {submitting && <Spin indicator={antIcon} />}
                </Row>
            </Form>
        )}

    </Drawer>
}

export default CreateTechnicianDrawer;


